import styled from 'styled-components'

export const ChartWrapper = styled.div<{
  heightTop: any
  heightBottom: any
  autoConfig: boolean
}>`
  width: 100%;
  height: ${({ autoConfig }: any) => (autoConfig ? '0px' : '200px')};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 9999;
  overflow: ${({ autoConfig }: any) => (autoConfig ? 'hidden' : '')};

  .top {
    position: absolute;
    left: 0;
    top: 0;
    height: ${({ heightTop }: any) => heightTop + 'px'};
    width: 100%;
    background: radial-gradient(
      54.74% 54.74% at 50% 92.63%,
      rgba(39, 74, 211, 0.1) 0%,
      rgba(39, 74, 211, 0) 100%
    );
    .tick {
      line {
        stroke: #2141c1;
      }
      &:last-child {
        line {
          stroke: transparent;
        }
      }
    }
  }
  .bottom {
    position: absolute;
    left: 0;
    bottom: 0;
    height: ${({ heightBottom }: any) => heightBottom + 'px'};
    width: 100%;
    transform: rotate(180deg);
    background: radial-gradient(
      54.74% 54.74% at 50% 92.63%,
      rgba(230, 55, 55, 0.15) 0%,
      rgba(230, 55, 55, 0) 100%
    );
    .tick {
      line {
        stroke: #dd2e2e;
      }
      &:last-child {
        line {
          stroke: transparent;
        }
      }
    }
  }
  .chart {
    height: 100%;
  }
  .stroke {
    stroke-width: 0.5px;
  }
  .middleLine {
    stroke-width: 0.5px;
    stroke-dasharray: 1.1;
    /* stroke-dashoffset: 1; */
  }

  .text {
    fill: white;
    font-family: 'Regular';
    font-size: 12px;
  }
`
